module.exports = __webpack_public_path__ + "img/xinxi.8efdbdf4.png";